import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppRoutesName } from '../../const/AppRoutesName';

// Historique des courriels — page « Courriels envoyés » (MODULE_EMAIL_HISTORY, GOD seulement).
export const routes: Routes = [
  {
    path: ':shop_uuid/' + AppRoutesName.EN.SENT_EMAILS,
    loadComponent: () =>
      import('./sent-emails.component').then((m) => m.SentEmailsComponent),
  },
  {
    path: ':shop_uuid/' + AppRoutesName.FR.SENT_EMAILS,
    loadComponent: () =>
      import('./sent-emails.component').then((m) => m.SentEmailsComponent),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SentEmailsModule {}
